import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/shell/page-header';
import { callersQuery, callSourceQuery } from '@/features/calls/calls-api';
import { TelegramScreen } from '@/features/calls/telegram-screen';
import { meQuery } from '@/lib/queries';

export const Route = createFileRoute('/_app/telegram')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(callSourceQuery);
    void queryClient.prefetchQuery(callersQuery);
  },
  component: TelegramRoute,
});

function TelegramRoute() {
  const { data: me } = useSuspenseQuery(meQuery);
  return (
    <>
      <PageHeader title="Telegram" />
      <TelegramScreen isAdmin={me.user.role === 'admin'} />
    </>
  );
}
